import useAppContext from '../../../../../hooks/useAppContext/useAppContext';

export default function IdSession() {
  const { sessionId, treatmentId, hasDevice } = useAppContext();

  return { sessionId: sessionId, treatmentId: treatmentId, hasDevice: hasDevice };
}
